import React from 'react';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';

const AdvancedSearchProductsGrid = ({ products }) => {
  const mobileColumnCount = useMobileColumnCount();
  return (
    <div className="md:space-y-8 md:mb-8 md:flex-1">
      <ProductCardGridUI
        limitWidth={false}
        columnsOnDesktop="auto"
        columnsOnMobile={mobileColumnCount}
      >
        {!!products &&
          products?.length > 0 &&
          products?.map(
            ({
              campaign,
              id,
              isClearance,
              isFavorited,
              isHidden,
              label,
              meta,
              name,
              onDisplayInShowroomSlug,
              path,
              position,
              productFamily,
              productLabel,
              productType,
              quickship,
              secondaryImage,
              secondaryImageCropData,
              slug,
              variants,
              variantsToShow,
              variantsTotal,
              moreVariantsCount,
              bypass_stock,
            }) => (
              <ProductCardStatic
                key={`advanced-search-product-${id}-${variantsToShow?.[0]
                  ?.sku ??
                  variants?.[0]?.sku ??
                  ''}`}
                campaign={campaign}
                enableMobileCarousel
                hidden={isHidden}
                id={id}
                isClearance={isClearance}
                isFavorited={isFavorited}
                label={label}
                layout="full"
                moreVariantsCount={
                  moreVariantsCount ??
                  variantsTotal - (variantsToShow?.length ?? 0)
                }
                name={name}
                onDisplayInShowroomSlug={onDisplayInShowroomSlug}
                path={path}
                position={position}
                productFamily={productFamily}
                productLabel={productLabel}
                productType={productType}
                quickship={quickship}
                secondaryImage={`${secondaryImage}`}
                secondaryImageCropData={secondaryImageCropData}
                slug={slug}
                variants={variants}
                variantsToShow={
                  variantsToShow?.map(variant => ({
                    ...variant,
                    image: `${variant.image}`,
                  })) ??
                  variants?.slice(0, 4).map(variant => ({
                    ...variant,
                    image: `${variant.image}`,
                  })) ??
                  []
                }
                variantsTotal={variantsTotal}
                meta={meta}
                bypass_stock={bypass_stock}
              />
            )
          )}
      </ProductCardGridUI>
    </div>
  );
};

export default AdvancedSearchProductsGrid;
